"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var TextInput = function (props) {
    return react_1.default.createElement("input", { className: "formsCommon-TextInput", value: props.value, placeholder: props.placeholder, onChange: function (e) { return props.onChange(e.target.value); } });
};
exports.default = TextInput;
